import { DeviceReadingResponse } from '@/domain/Historical/Historical';
import { ChartDataPoint, ChartInfo, ChartUtilResult, HistoricalDataConfig } from '@/components/General/PlayerChart/types';
import { Parameter } from '@/pages/InteractiveSimulation/types/replayInteractive';


interface HistoricalValue {
	v: number | null;  
	s: string | null; 
	q: number | null; 
}

export function transformHistoricalData(
	historicalData: DeviceReadingResponse, 
	parameter: Parameter
): ChartUtilResult {

	if (!historicalData?.measurementToolHistoricalValues) {
		return {
			info: {
				name: `${parameter.infraestructureName} | ${parameter.paremeterName}`,
			},
			data: [],
			paramId: parameter.paremeterId.toString(),
		};
	}

	
	const data: ChartDataPoint[] = Object.entries(historicalData.measurementToolHistoricalValues as Record<string, HistoricalValue>)
		.map(([timestampStr, reading]) => {
			
			const timestamp = parseInt(timestampStr, 10);

			
			if (reading.v !== null) {
				return {
					x: timestamp,
					y: reading.v,
				};
			}
			return null;
		})
		.filter((point): point is ChartDataPoint => point !== null)
		.sort((a, b) => a.x - b.x);


	const info: ChartInfo = {
		name: `${parameter.infraestructureName} | ${parameter.paremeterName}`,
	};

	return {
		info,
		data,
		paramId: parameter.paremeterId.toString(),
	};
}


export function transformMultipleHistoricalData(
	historicalDataMap: Record<string, DeviceReadingResponse | null>,
	parameters: Parameter[]
): HistoricalDataConfig[] {
	return parameters
		.map((parameter) => {
			const historicalData = historicalDataMap[parameter.paremeterId.toString()];
			
			if (!historicalData) {
				return null;
			}

			const transformedData = transformHistoricalData(historicalData, parameter);
			
			return {
				data: transformedData,
				paramId: parameter.paremeterId.toString(),
			};
		})
		.filter((config): config is HistoricalDataConfig => config !== null);
}

